import React from 'react';

export default function Sobre() {
    return <div style={{ padding: 10 }}>
        <p style={{ textAlign: "center" }}>PDV</p>
        <p style={{ textAlign: "center" }}>Versão: 1.01</p>
    </div>;
}